import styled from 'styled-components';
import { rem } from '@/styles/theme';


export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.color['gray-600']}; 
  font-size: ${rem(12)};
  ${({ theme }) => theme.media.fold`
    font-size: ${rem(10)}
  `}
  
`